import { MockServiceStore } from "./MockServiceStore";

/**
 * StructureCast - Client
 */
export interface StructureCastClient {
  id: string;
  clientCode: string;
  clientName: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  notes: string;
  status: "active" | "inactive";
  createdAt: string;
  updatedAt: string;
}

export const mockStructureCastClients: StructureCastClient[] = [
  {
    id: "sc-client-1",
    clientCode: "HRCSD",
    clientName: "Heritage Ranch Community Services District",
    contactName: "Greg Hill",
    contactEmail: "ghill@heritageranchcsd.org",
    contactPhone: "805-227-6230",
    address: "4870 Heritage Rd",
    city: "Paso Robles",
    state: "CA",
    zipCode: "93446",
    notes: "Heritage Ranch WRRF (Water Resource Recovery Facility) — Job #25-1585. Sanitary sewer collection upgrade: 48\" precast manhole network with eccentric cones, extended bases w/ inverts, grade rings, and 1900 CPH frame & cover assemblies. Press-Seal cast-in pipe boots. 5,000 PSI Type II/V Low Alkali. Net 30. San Luis Obispo County (7.25% sales tax).",
    status: "active",
    createdAt: "2025-05-29T00:00:00.000Z",
    updatedAt: "2025-11-15T00:00:00.000Z",
  },
];

export const createMockStructureCastClientStore = () =>
  new MockServiceStore<StructureCastClient>({
    mockData: mockStructureCastClients,
    idField: "id",
    simulateDelay: 200,
    persistKey: "preferred-structurecast-clients",
  });

export default mockStructureCastClients;
